import styled from 'styled-components';


const Container = styled.div`
  margin: 0 -30px -10px;
  box-sizing: border-box;
  width: 1200px;
  background-color: ${props => props.theme.color.backgroundRush};
  border-radius: 20px;
`;

interface RowProps {
  planLength: number;
}
const Row = styled.div<RowProps>`
  display: grid;
  grid-template-columns: 300px 1fr 1fr 1fr ${props => props.planLength > 3 && '1fr'};
  grid-template-rows: 90px;

  & + & {
    grid-template-rows: 55px;

    > div {
      padding-top: 0;
    }
  }
`;

const FeatureHead = styled.div`
  display: flex;
  padding: 35px 30px;

  > div {
    margin: 0 20px;
  }
`;

const FeatureValue = styled.div`
  display: flex;
  justify-content: center;
  padding: 35px;
  border-left: 1px solid ${props => props.theme.color.background};
`;

export const Styled = {
  Container,
  Row,
  FeatureHead,
  FeatureValue,
};
